export const asFlash = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M.667.333v7.333h2v6l4.666-8H4.666l2-5.333h-6Z" fill="#818F99"/></svg>`,
  name: 'flash',
};
